enum REACTION {
  THUMBS_UP = 'THUMBS UP',
  THUMBS_DOWN = 'THUMBS DOWN',
  NEUTRAL = 'NEUTRAL',
}

export default REACTION;
